import Vue from 'vue'

import './styles/quasar.sass'
import 'quasar/dist/quasar.ie.polyfills'
import lang from 'quasar/lang/zh-hans.js'
import '@quasar/extras/material-icons/material-icons.css'
import '@quasar/extras/fontawesome-v5/fontawesome-v5.css'
import { Quasar,Notify,Dialog,Cookies,Loading } from 'quasar'

Vue.use(Quasar, {
  config: {},
  components: [
    'QDialog'
  ],
  directives: [
    'ClosePopup'
  ],
  plugins: [Notify,Dialog,Cookies,Loading],
  lang: lang
 })